import { isObj } from '../../globalUtils';

// This function is used to create storeMasks for individual items:
export const appendId = (storeMask, id) => `${storeMask}_${id}`;
export const getStoreKey = (...args) => args.join('/');
export const coerceToObj = (obj) => (isObj(obj) ? obj : {});
